const vampireMousePlayerSpritesheet = {
  "name": "vampireMousePlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 2,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/vampireMousePlayerSpritesheet.png",
  "sprites": {
    "vampireMousePlayerHead": [0],
    "vampireMousePlayerBody": [1]
  }
}
export default vampireMousePlayerSpritesheet;
